import * as React from 'react';
export const arrowDecreaseSvg = React.forwardRef(function arrowDecreaseSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15 12.875h-4a.875.875 0 0 1 0-1.75h1.888L9 7.237 6.619 9.62a.875.875 0 0 1-1.238 0l-5-5A.875.875 0 0 1 1.62 3.38L6 7.763 8.381 5.38a.875.875 0 0 1 1.238 0l4.506 4.507V8a.875.875 0 0 1 1.75 0v4a.875.875 0 0 1-.875.875Z',
    }),
  );
});
arrowDecreaseSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arrowDecrease = {
  category: 'icon',
  colorable: true,
  name: 'arrowDecrease',
  svg: arrowDecreaseSvg,
};
